import { SOCIAL_KEY } from '@src/constants/FJShareSocialConstant.ts';
const environment = import.meta.env.MODE; // 当前环境
import { LOCAL, RELEASE } from '../constants/FJEvnConstant';
const VERSION = '1.0.4.3.1';
import ORT_WASM_VERSION from './ortWasmVersion.js';
const VERSION_CONFIG = {
    codecResourceVersion: '1.0.4', // code 路径的版本
    wasmResourceVersion: '1.0.4', // wasm 资源路径的版本
    staticResourceVersion: '1.0.0', // 静态资源路径的版本
    // common worker 路径的版本
    commonWorkerResourceVersion: '1.1.2',
    // 几乎不更新的资源，比如具体的元素数据
    thirdResourceVersion: '1.0.30',
    // 字体文件数据的本地缓存版本
    fontCacheVersion: '1.0.1',
    u2netpVersion: '1.0.1',
};
const toolFileName = 'ai-long-to-shorts';
const isLocal = environment === LOCAL;
const isRelease = environment === RELEASE;
const TEST_URL = 'https://www.smartvideomaker.com/';
const labPath = isLocal ? `/public/lib/` : `/app/${toolFileName}/lib/`;
const FJConfig = {
    VERSION,
    IS_TEST: !isRelease,
    JOB_TYPE: 101,
    BASE_URL: isRelease ? '/' : 'https://www.smartvideomaker.com/',
    VIDEO_THUMBNAIL_WORKER_PATH: isLocal
        ? `/public/lib/work/thumbnail/2.0.18/videoThumbnailWorker.js`
        : `/app/${toolFileName}/lib/work/thumbnail/2.0.18/videoThumbnailWorker.min.js`,
    LIB_PATH: labPath,
    WASM_VERSION: VERSION_CONFIG.wasmResourceVersion,
    CODEC_VERSION: VERSION_CONFIG.codecResourceVersion,
    RESOURCE_SERVER: isRelease ? 'https://resource.flexclip.com/' : TEST_URL,
    SUBTITLE_STYLE_PATH: 'app/resource/subtitleStyle/',
    STATIC_RESOURCE_VERSION: VERSION_CONFIG.staticResourceVersion,
    COMMON_WORKER_PATH: isLocal
        ? `/public/process/${VERSION_CONFIG.commonWorkerResourceVersion}/common.worker.js`
        : `/app/${toolFileName}/process/${VERSION_CONFIG.commonWorkerResourceVersion}/common.worker.js`,
    THIRD_RESOURCE_VERSION: VERSION_CONFIG.thirdResourceVersion,
    FONT_CACHE_VERSION: VERSION_CONFIG.fontCacheVersion,
    LANGUAGE_PATH: environment === LOCAL ? `/public/language/local.` : `/app/${toolFileName}/language/local.`,
    FACE_MODEL_URL: environment === LOCAL ? '/public/face-models/' : `/app/${toolFileName}/face-models/`,
    /** 主体检测 U²-Net 系模型目录（默认轻量 U²-Netp，约 4.6MB） */
    SUBJECT_MODEL_URL:
        environment === LOCAL
            ? `/public/subject-models/${VERSION_CONFIG.u2netpVersion}/u2netp`
            : `/app/${toolFileName}/subject-models/${VERSION_CONFIG.u2netpVersion}/u2netp`,
    /** ONNX Runtime Web WASM 目录（与 @huggingface/transformers 版本对应，postinstall 复制到 public） */
    ORT_WASM_PATH: isLocal
        ? `/public/lib/ort/${ORT_WASM_VERSION}/`
        : `/app/${toolFileName}/lib/ort/${ORT_WASM_VERSION}/`,
    PRODUCE_AUDIO_WORKER_PATH: `${labPath}/audioWorker/produceAudio.js?`,
    IMG_PATH: isLocal ? `/public/images/` : `/app/${toolFileName}/images/`,
    VIDEO_PATH: isLocal ? `/public/videos/` : `/app/${toolFileName}/videos/`,
    mediaMaxSize: 1024 * 1024 * 1024 * 3,
    SOCIAL_TYPES: [SOCIAL_KEY.YOUTUBE, SOCIAL_KEY.LINKEDIN],
    /** 首页最近文件 / get-task-list 每页条数（与 offset、limit 请求一致） */
    TASK_LIST_PAGE_SIZE: 20,
    YOUTUBE_DOWNLOAD_SCHEME: 'FLEX_CLIP', // FLEX_CLIP我们后台服务器方案    SERVICE_PROVIDER:服务商方案
    VIDEO_UPLOAD_MIN_DURATION_SEC: 60,
    VIDEO_UPLOAD_MAX_DURATION_SEC: 120 * 60,
};
console.log('long to shorts version:', VERSION);
window.isTest = false; // 测试人员
export default FJConfig;
